import { Button, Drawer, Space, Typography } from "@payping/web-components";
import { Branches, Close } from "@payping/icons";
import { FC } from "react";
import { useAppTranslation, useLastUrlWasPage } from "@/utils";
import { Trans } from "@payping/utils/localeUtils";
import { CustomLink } from "@/components/CustomLink";
import { changeLog } from "./data";

const ChangeLog: FC = () => {
  const { t } = useAppTranslation();
  const { navigateToLast } = useLastUrlWasPage();

  return (
    <Drawer
      open
      title={t("lastChanges")}
      height={"100%"}
      placement={"bottom"}
      closeIcon={false}
      className={"px-1"}
      extra={
        <Button
          type={"text"}
          icon={<Close width={14} height={14} />}
          onClick={() => {
            navigateToLast();
          }}
        />
      }
    >
      {changeLog.map(({ links, version }, index) => {
        const translationVersion = version.replace(/\./g, "-");
        return (
          <div key={index} className={"mt-3"}>
            <Space className={"w-100"}>
              <Branches width={14} />
              <Typography.Title level={5} className={"m-0 font-bold"}>
                {t("changes")}
              </Typography.Title>
              <Typography.Title level={5} className={"m-0 font-bold"}>
                {version}
              </Typography.Title>
            </Space>

            <Typography.Text type={"secondary"}>{t(`releaseNotes.${translationVersion}.date`)}</Typography.Text>
            <ul className={"mt-1"}>
              {
                // @ts-expect-error wrong type for returnObjects: true
                [...t(`releaseNotes.${translationVersion}.features`, { returnObjects: true })].map(
                  (_: string, i: number) => (
                    <li key={i} className={"color--gray500"}>
                      <Trans
                        i18nKey={`Wrapper:releaseNotes.${translationVersion}.features.${i}`}
                        components={[
                          <span key={"emoji"} />,
                          ...(links[i] || []).map((link: string, j: number) => <CustomLink key={j} to={link} />),
                        ]}
                      />
                    </li>
                  ),
                )
              }
            </ul>
          </div>
        );
      })}
    </Drawer>
  );
};

export default ChangeLog;
